var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, CustomElement, Watch, COMPONENT_STATE, html } from '@sick-davinci/ce-decorators';
import { Icon } from '../icon/Icon';
import { IconRef } from '../icon/IconRef';
/**
 * Base clas for slider
 */

export let AbstractSlider = (_dec = Component({
  abstract: true,
  dependencies: [Icon, IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Number), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Number), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", String), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", String), _dec20 = Prop(), _dec21 = Reflect.metadata("design:type", String), _dec22 = Watch('disabled'), _dec23 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec(_class = (_class2 = (_temp = class AbstractSlider extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "min", _descriptor, this);

    _initializerDefineProperty(this, "max", _descriptor2, this);

    _initializerDefineProperty(this, "ticks", _descriptor3, this);

    _initializerDefineProperty(this, "legend", _descriptor4, this);

    _initializerDefineProperty(this, "unit", _descriptor5, this);

    _initializerDefineProperty(this, "disabled", _descriptor6, this);

    _initializerDefineProperty(this, "iconLeft", _descriptor7, this);

    _initializerDefineProperty(this, "iconRight", _descriptor8, this);

    _initializerDefineProperty(this, "iconSrcLeft", _descriptor9, this);

    _initializerDefineProperty(this, "iconSrcRight", _descriptor10, this);

    this.requestAnimationFrame = null;

    this.roundWithTicks = value => {
      if (this.ticks > 0) {
        const displacement = (value - this.min) % this.ticks;

        if (displacement >= this.ticks / 2) {
          value = value + (this.ticks - displacement);
        } else {
          value = value - displacement;
        }

        return value;
      } else {
        return value;
      }
    };
  }

  disabledChangeHandler(_, newValue) {
    if (this._componentState !== COMPONENT_STATE.INIT) {
      // avoid setting illegal attribute set during construction
      if (!newValue) {
        // with this code the focused slider has a blue highlighting-box
        this.setAttribute('tabindex', '0');
      }
    }
  }

  getPositionXOf(event) {
    let positionX = event.clientX;

    if (positionX === undefined) {
      positionX = event.changedTouches[0].clientX;
    }

    return positionX;
  }

  calcValueFrom(positionX) {
    const {
      left,
      width
    } = this.shadowRoot.querySelector('.bar_container').getBoundingClientRect();
    const normalized = positionX - left;
    let value = this.map(normalized, 0, width, this.min, this.max);
    value = this.roundWithTicks(value);
    return this.validateValue(value);
  }

  validateValue(value) {
    if (isNaN(value)) {
      value = 0;
    }

    if (value <= this.min) {
      value = this.min;
    } else if (value >= this.max) {
      value = this.max;
    }

    return value;
  }

  map(value, inMin, inMax, outMin, outMax) {
    return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
  }

  displayLegend() {
    let legend = null;

    if (this.legend) {
      legend = html`
      <div class ="legend">
        <div class ="verticalLines">
          <div class="verticalLine"></div>
          <div class="verticalLine"></div>
          <div class="verticalLine"></div>
        </div>
        <div class ="values">
          <div class="value" style="left:0%">${this.min}${this.unit}</div>
          <div class="value" style="left:50%">${(this.max - this.min) / 2 + this.min}${this.unit}</div>
          <div class="value" style="left:100%">${this.max}${this.unit}</div>
        </div>
      </div>
    `;
    }

    return legend;
  }

  renderIcon(iconSrc, icon) {
    let iconRendered = null;

    if (iconSrc) {
      iconRendered = html`<davinci-icon-ref src=${iconSrc}></davinci-icon-ref>`;
    }

    if (icon) {
      iconRendered = html`<davinci-icon icon=${icon}></davinci-icon>`;
    }

    return iconRendered;
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "min", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "max", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 100;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "ticks", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "legend", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "iconLeft", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "iconRight", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "iconSrcLeft", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "iconSrcRight", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "disabledChangeHandler", [_dec22, _dec23], Object.getOwnPropertyDescriptor(_class2.prototype, "disabledChangeHandler"), _class2.prototype)), _class2)) || _class);
//# sourceMappingURL=AbstractSlider.js.map